import {KpiRangeBreachSeverity} from '@hconnect/common/types'
import {formatNumber} from '@hconnect/common/utils'
import {Icon, icon, TextRegular, Tooltip} from '@hm/fundamental'
import {Stack, Typography} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {KPIS_WIDGET_NAMESPACE} from '../consts'

import {KpiThresholdIcon} from './KpiThresholdIcon'

// The KPI backend reports calculation failures as ERR_* codes in the value field
const KPI_ERROR_VALUE_PREFIX = 'ERR_'

type Props = {
  // The API can omit the value at runtime
  value?: string
  language?: string
  unit?: string
  showKpiStatusIndicator?: boolean
  kpiBreachSeverity: KpiRangeBreachSeverity | null
  dataTestId?: string
}
export const KpiValue: React.FC<Props> = ({
  value,
  language,
  unit,
  showKpiStatusIndicator,
  kpiBreachSeverity,
  dataTestId
}) => {
  const {t} = useTranslation(KPIS_WIDGET_NAMESPACE)
  const text = value ?? ''
  const numericValue = parseFloat(text)
  const isErrorValue = text.startsWith(KPI_ERROR_VALUE_PREFIX)

  return (
    <Stack direction="row" spacing={1} justifyContent="flex-end" alignItems="center">
      {isErrorValue ? (
        <Tooltip content={text}>
          <div data-test-id="kpi-value-error" className="flex items-center gap-2 whitespace-nowrap">
            <Icon path={icon.mdiInformationOutline} />
            <TextRegular>{t('equipmentKpi.message.noData')}</TextRegular>
          </div>
        </Tooltip>
      ) : (
        <Typography variant="body1" sx={{textAlign: 'right', whiteSpace: 'nowrap'}}>
          {!isNaN(numericValue)
            ? `${formatNumber(numericValue, language ?? '')}${unit ? ` ${unit}` : ''}`
            : text || '-'}
        </Typography>
      )}
      {showKpiStatusIndicator && !!kpiBreachSeverity && (
        <KpiThresholdIcon status={kpiBreachSeverity} dataTestId={dataTestId} />
      )}
    </Stack>
  )
}
